<template>
  <v-dialog v-model="show" max-width="500" persistent>
    <v-card>
      <v-card-title>
        {{ deposit ? $t("finance_edit_deposit_title") : $t("finance_report_deposit") }}
      </v-card-title>
      <v-divider />
      <v-card-text class="pt-4">
        <v-form ref="form" v-model="valid">
          <v-row dense>
            <v-col cols="6">
              <date-picker
                v-model="form.date"
                singleDate
                :label="$t('finance_date')"
                :rules="[rules.required]"
              />
            </v-col>
            <v-col cols="6">
              <text-field
                v-model.number="form.amount"
                :label="$t('finance_amount_currency', { currency: restaurantCurrency })"
                type="number"
                kind="money"
                :rules="[rules.required, rules.positive]"
              />
            </v-col>
          </v-row>
          <text-field
            v-model="form.method"
            :label="$t('finance_payment_method_hint')"
            prependInnerIcon="mdi-credit-card-outline"
            :rules="[rules.required]"
          />
          <text-field
            v-model="form.reference"
            :label="$t('finance_reference')"
            prependInnerIcon="mdi-pound"
            :rules="[rules.required]"
          />
          <text-field
            v-model="form.bankTransaction"
            :label="$t('finance_bank_transaction_optional')"
            prependInnerIcon="mdi-bank-outline"
          />
          <text-field
            v-model="form.proof"
            :label="$t('finance_proof_link_optional')"
            prependInnerIcon="mdi-paperclip"
          />
          <text-area v-model="form.note" :label="$t('finance_note_optional')" rows="2" />
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn text :disabled="saving" @click="close">{{ $t("finance_cancel") }}</v-btn>
        <primary-button :loading="saving" @click="submit">{{ $t("finance_save") }}</primary-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const emptyForm = () => ({
  date: "",
  amount: 0,
  method: "",
  reference: "",
  bankTransaction: "",
  proof: "",
  note: "",
});

export default {
  name: "DepositFormDialog",

  props: {
    value: { type: Boolean, default: false },
    saving: { type: Boolean, default: false },
    deposit: { type: Object, default: null },
  },

  data() {
    return {
      valid: true,
      form: emptyForm(),
      rules: {
        required: (v) => (v !== null && v !== undefined && v !== "") || this.$t("finance_required_field"),
        positive: (v) => Number(v) > 0 || this.$t("finance_amount_must_be_positive"),
      },
    };
  },

  computed: {
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  watch: {
    value(isOpen) {
      if (!isOpen) return;
      if (this.deposit) {
        this.form = {
          date: (this.deposit.date || "").slice(0, 10),
          amount: this.deposit.amount,
          method: this.deposit.method,
          reference: this.deposit.reference,
          bankTransaction: this.deposit.bankTransaction || "",
          proof: this.deposit.proof || "",
          note: this.deposit.note || "",
        };
      } else {
        this.form = emptyForm();
      }
      this.$nextTick(() => this.$refs.form && this.$refs.form.resetValidation());
    },
  },

  methods: {
    close() {
      this.$emit("input", false);
    },
    submit() {
      if (!this.$refs.form.validate()) return;
      this.$emit("save", {
        date: this.form.date,
        amount: Number(this.form.amount),
        method: this.form.method,
        reference: this.form.reference,
        bank_transaction: this.form.bankTransaction || undefined,
        proof: this.form.proof || undefined,
        note: this.form.note || undefined,
      });
    },
  },
};
</script>
